import { Dialog, Typography, Button, Spacing } from 'components/src';
import { View } from 'react-native';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { deleteMessage, Store } from '../store';
import { SocketIOContext } from 'components/src/app/appcontainer';

interface AskProps {
  openAsk: boolean;
  setOpenAsk: any;
  propsState: any;
  props2State: any;
  conversationId: string;
  setDeleteMessageList: any;
}

const AskModal: React.FC<AskProps> = ({
  openAsk,
  setOpenAsk,
  propsState,
  props2State,
  conversationId,
  setDeleteMessageList,
}) => {
  const { i18n } = useTranslation();
  const dispatch = Store.useDispatch();

  const handleDelete = (props: any, a: any) => {
    dispatch(deleteMessage([a?.id]), () => {
      SocketIOContext?.invoke('deleteMessage', {
        messageIds: [a?.id],
        conversationId: conversationId,
      });
    });
    setDeleteMessageList([a?.id]);
  };

  return (
    <Dialog modalVisible={openAsk}>
      <View>
        <Typography text={i18n.t('areYouSureYouWantToDeleteThisMessage')} />
        <Spacing vertical={10} />
        <View style={{ flexDirection: 'row', justifyContent: 'flex-start' }}>
          <Button
            onClick={() => {
              handleDelete(propsState, props2State);
              setOpenAsk(false);
            }}
          >
            <Typography color="red" text={i18n.t('delete')} />
          </Button>
          <Spacing horizontal={10} />
          <Button
            onClick={() => {
              setOpenAsk(false);
            }}
          >
            <Typography color="blue" text={i18n.t('cancel')} />
          </Button>
        </View>
      </View>
    </Dialog>
  );
};

export default AskModal;
